import { View } from 'react-native';

type PagerStatus = 'active' | 'inactive' | 'crossed';

type Props = {
  list: number[];
  activePager: number;
};

const backgroundColor = {
  active: 'bg-green-neolexon',
  inactive: 'bg-slate-600 mx-0.5 w-3 aspect-square rounded-full',
  crossed: 'bg-slate-400 mx-0.5 w-3 aspect-square rounded-full',
};

const getPagerStatus = (
  currentItem: number,
  activeItem: number,
): PagerStatus => {
  if (currentItem === activeItem) {
    return 'active';
  }
  if (currentItem < activeItem) {
    return 'crossed';
  }
  return 'inactive';
};

export const PagerList = ({ list, activePager }: Props) => {
  return (
    <View className="flex-1 flex-row justify-center items-center">
      {list.map((item, index) => {
        const status = getPagerStatus(item, activePager);
        return <PagerItem key={index} pagerStatus={status} />;
      })}
    </View>
  );
};

const PagerItem = ({ pagerStatus }: { pagerStatus: PagerStatus }) => {
  return (
    <View
      className={`mx-0.5 w-3 aspect-square rounded-full ${backgroundColor[pagerStatus]}`}
    />
  );
};
